/**
 * Get the name of the targeted location
 *
 * @param {Node} node - HTML node
 * @returns {string} Name of the location
 */
 export function getLocationName(node) {
	return node && node.attributes.name.value
}

/**
 * Get the name of the selected location
 *
 * @param {Object} map - Map of component
 * @param {string} locationId - Id of selected location
 * @returns {string} Name of the selected location
 */
export function getSelectedLocationName(map, locationId) {
	return locationId && map.locations.find(location => location.id === locationId).name
}

export function Gc_pic_url(id){
	
	switch(id){
		case 3166398:
		return {name : "Jennifer Rietzler",
		pic : "https://geneticsupportfoundation.org/wp-content/uploads/GSF-Team-JenniferRietzler-1.png"};
		case 2379280:
		return {name : "Rachel Westman",
		pic : "https://geneticsupportfoundation.org/wp-content/uploads/GSF-Team-RachelWestman-1.png"};
		case 2470515: 
		return {name : "Jerri Cheung",
		pic : "https://geneticsupportfoundation.org/wp-content/uploads/GSF-Team-JerriCheung-1.png"};
		case 1074804:
		return {name : "Jen Eichmeyer",
		pic : "https://s3.amazonaws.com/acuitys/calendar-thumb-1074804.jpg"};
		case 804825:
		return {name : "Austin McKittrick",
		pic : "https://s3.amazonaws.com/acuitys/calendar-thumb-804825.jpg"} ;
		case 797328: 
		return {name : "Katie Stoll",
		pic : "https://s3.amazonaws.com/acuitys/calendar-thumb-797328.jpg"};
		case 1488205:  
		return {name : "Kelly Donahue",
		pic : "https://geneticsupportfoundation.org/wp-content/uploads/GSF-Team-KellyDonahue-1.png"};
		case 1124346:
		return {name : "Amy Kunz",
		pic : "https://s3.amazonaws.com/acuitys/calendar-thumb-1124346.jpg"};
		case 1715654:
		return {name : "Julie Simon",
		pic : "https://geneticsupportfoundation.org/wp-content/uploads/GSF-Team-JulieSimon.png"};
		case 1488325:
		return {name : "Amber Volk",
		pic : "https://geneticsupportfoundation.org/wp-content/uploads/GSF-Team-AmberVolk-1.png"};
		case 5963732 : 
		return {
			name : "Alyssa Stringfellow",
			pic : "https://geneticsupportfoundation.org/wp-content/uploads/GSF-Team-AlyssaStrongfellow-1.png"
		};
		case 6881176 : 
		return {
			name : "Devin Shuman",
			pic : "https://cdn-s.acuityscheduling.com/calendar-thumb-6881176.png?1653448894"
		};
		case 8435746:
			return {
				name : "Chase Beeler",
				pic : "https://cdn-s.acuityscheduling.com/calendar-thumb-8435746.jpg?1685588974"
			}
			case 8435750:
				return {
					name : "Jada Roberts",
					pic : "https://cdn-s.acuityscheduling.com/calendar-thumb-8435750.jpg?1685588991"
				}
		default:
		return {name : "",
		pic : "user.png"};
	}    
}

export  function working_GC(type){
	//0 Amber 1488325
	//1 Austin 804825
	//2 Katie 797328
	//3 Jen 1074804
	//4 Julie 1715654
	//5 Kelly 1488205
	//6 Amy 1124346
	//7 Rachel 2379280
	//8 Jerri 2470515
	//9 Jennifer 3166398
	//10 Alyssa 5963732
	//11 Devin 6881176
	//12 Chase 8435746
	//13 Jada 8435750
	//to do, maybe add these logic to a config file?
	
	var toRemove = [];
	var gc =  [1488325,804825,797328,1074804,1715654,1488205,1124346,2379280,2470515,3166398,5963732,6881176,8435746,8435750];

	switch (type){
	case "1":
	toRemove = [3,5,6,7,9,11];
	toRemove.reverse().forEach(function(index) {
	gc.splice(index, 1);
	});
	return gc;
	case "2" :
		//1,9,8,5,2
	toRemove = [0,3,4,6,7];
	toRemove.reverse().forEach(function(index) {
	gc.splice(index, 1);
	});
	return gc;
	case "3":
	toRemove = [0,3,5,6,8,9];
	toRemove.reverse().forEach(function(index) {
	gc.splice(index, 1);
	});
	return gc;
	case "4":
	toRemove = [0,1,2,3,5,6,8,9];
	toRemove.reverse().forEach(function(index) {
	gc.splice(index, 1);	
	});
	return gc;
	case "5":
	toRemove = [0,1,2,3,6,8,9];
	toRemove.reverse().forEach(function(index) {
	gc.splice(index, 1);	
	});
	return gc;
	case "6":
	case "7":
	// 1,9,8,4,2,5,7
	toRemove = [0,3,6,];
	toRemove.reverse().forEach(function(index) {
	gc.splice(index, 1);	
	});
	return gc;
	default : 
	return gc;
	}
}